import React from 'react';

const LegalPage = ({ title, subtitle, sections, testId }) => {
  return (
    <main data-testid={testId} className="bg-white">
      <section className="pt-36 lg:pt-44 pb-16 lg:pb-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <div className="overline mb-6">Información legal</div>
          <h1 className="display-xl text-cyan-vidat">{title}</h1>
          <span className="section-rule mt-10 mb-10"></span>
          {subtitle && (
            <p className="text-lg text-stone-600 font-light leading-relaxed max-w-2xl">{subtitle}</p>
          )}
        </div>
      </section>

      <section className="bg-ivory py-20 lg:py-24">
        <div className="max-w-[900px] mx-auto px-6 lg:px-12">
          <div className="space-y-14">
            {sections.map((section, i) => (
              <article key={i} data-testid={`legal-section-${i}`}>
                <div className="font-mono text-xs tracking-widest text-cyan-vidat mb-3">
                  {String(i + 1).padStart(2, '0')}
                </div>
                <h2 className="font-display text-2xl lg:text-3xl text-cyan-vidat font-light tracking-tight mb-5">
                  {section.title}
                </h2>
                <div className="prose-vidat">
                  {section.body.map((block, j) => {
                    if (typeof block === 'string') {
                      return <p key={j}>{block}</p>;
                    }
                    if (block.type === 'list') {
                      return (
                        <ul key={j} className="my-4 space-y-2.5 list-none pl-0">
                          {block.items.map((it, k) => (
                            <li key={k} className="flex gap-4 items-start text-stone-700 font-light leading-relaxed text-base">
                              <span className="block mt-[0.7em] w-2.5 h-px bg-[#0936F6] flex-shrink-0"></span>
                              <span>{it}</span>
                            </li>
                          ))}
                        </ul>
                      );
                    }
                    if (block.type === 'subtitle') {
                      return (
                        <h3 key={j} className="text-base font-medium text-cyan-vidat mt-6 mb-2">
                          {block.text}
                        </h3>
                      );
                    }
                    if (block.type === 'block') {
                      return (
                        <div key={j} className="border-l-2 border-[#1E3A8A]/40 pl-5 my-5 text-stone-700 font-light leading-relaxed">
                          {block.lines.map((l, k) => <div key={k}>{l}</div>)}
                        </div>
                      );
                    }
                    return null;
                  })}
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default LegalPage;
